<template>
    <div class="kotbot-message-with-feedback">
        <div class="kotbot-message">
            <!-- Use v-html to render HTML safely -->
            <div class="message-header">
                <div class="message-photo">
                    <img src="@/assets/isotipo_chatpts_transparente.svg" :alt="botname" />
                </div>
                <h2>{{ botname }}</h2>
            </div>
            <h2 v-if="isLoading" class="cargando-titulo">Cargando <span class="dot-1">.</span><span
                    class="dot-2">.</span><span class="dot-3">.</span></h2>
            <div class="message-text" :class="isLoading ? 'loading' : ''"
                v-html="streamAhora ? mensajeMostrado : parsedText"></div>
            <div v-if="!isLoading" class="botones">
                <button class="compartirPregunta" @click="compartirPregunta"> <ion-icon
                        name="share"></ion-icon>Compartir
                    respuesta</button>
                <button class="copiarPregunta" @click="copyToClipboard"> <ion-icon name="copy"></ion-icon>Copiar
                    respuesta</button>
            </div>
            <div v-if="groupedSources?.length" class="sources-container">
                <h4>Fuentes:</h4>
                <div class="source-chips">
                    <SourceChipComponent v-for="groupedSource in groupedSources"
                        :key="groupedSource.url || groupedSource.filename"
                        :sources_number="groupedSource.sources_number" :title="groupedSource.title"
                        :url="groupedSource.url"
                        :filename="groupedSource.filename ? groupedSource.filename.split('/').pop() : ''"
                        :pages="groupedSource.pages" :date="groupedSource.date" :sinopsis="groupedSource.sinopsis"
                        :author="author" />
                </div>
            </div>
            <div v-if="showTimestamp && this.timestamp" class="timestamp">{{ formattedTimestamp }}</div>
            <div class="triangle"></div>
        </div>
        <template v-if="!fromAdmin">
            <div v-if="!isLoading && !has_feedback" class="feedback-macro-container">
                <div v-if="!providedFeedback || !providedDetailedFeedback" class="feedback">
                    <h4>¿Te resultó útil?</h4>
                    <div v-if="!providedFeedback" class="numeric-feedback">
                        <button @click="sendPositiveFeedback">👍🏽</button>
                        <button @click="sendNegativeFeedback">👎🏽</button>
                    </div>
                    <div v-if="!providedDetailedFeedback && providedFeedback" class="detailed-feedback">
                        <p>Feedback enviado. Si podés, especificá más detalles de por qué fue una buena o mala respuesta
                            (p.
                            ej.: falta información, la información está bien pero está mal redactada, tiene poco
                            diálogo,
                            etc.).</p>
                        <textarea v-model="feedbackDetail" v-on:keyup.enter="sendDetailedFeedback"
                            placeholder="Detalles adicionales"></textarea>
                        <div class="detailed-feedback-buttons">
                            <button class="secondary" @click="cancelNumericFeedback">Volver</button>
                            <button @click="sendDetailedFeedback">Enviar</button>
                        </div>
                    </div>
                </div>
                <div v-else class="feedback-result">
                    <p>Gracias por tu feedback!</p>
                    <h3>{{ feedbackValue ? "👍🏽 (Positivo)" : "👎🏽 (Negativo)" }}</h3>
                    <p v-if="feedbackDetail"><span>Detalle:</span> "{{ feedbackDetail }}"</p>
                    <button @click="cancelarFeedback">Cambiar feedback</button>
                </div>
            </div>
        </template>
        <template v-else>
            <div v-if="!isLoading && !has_admin_feedback" class="feedback-macro-container">
                <div v-if="!providedFeedbackAdmin || !providedDetailedFeedbackAdmin" class="feedback">
                    <h4>Feedback [ADMIN]:</h4>
                    <div v-if="!providedFeedbackAdmin" class="numeric-feedback">
                        <button @click="sendPositiveFeedbackAdmin">👍🏽</button>
                        <button @click="sendNegativeFeedbackAdmin">👎🏽</button>
                    </div>
                    <div v-if="!providedDetailedFeedbackAdmin && providedFeedbackAdmin" class="detailed-feedback">
                        <p>Feedback [ADMIN] enviado. Si podés, especificá más detalles de por qué fue una buena o mala
                            respuesta
                            (p.
                            ej.: falta información, la información está bien pero está mal redactada, tiene poco
                            diálogo,
                            etc.).</p>
                        <textarea v-model="feedbackDetail" v-on:keyup.enter="sendDetailedFeedbackAdmin"
                            placeholder="Detalles adicionales"></textarea>
                        <div class="detailed-feedback-buttons">
                            <button class="secondary" @click="cancelNumericFeedbackAdmin">Volver</button>
                            <button @click="sendDetailedFeedbackAdmin">Enviar</button>
                        </div>
                    </div>
                </div>
                <div v-else class="feedback-result">
                    <p>Gracias por tu feedback!</p>
                    <h3>{{ feedbackValue ? "👍🏽 (Positivo)" : "👎🏽 (Negativo)" }}</h3>
                    <p v-if="feedbackDetail"><span>Detalle:</span> "{{ feedbackDetail }}"</p>
                    <button @click="cancelarFeedback">Cambiar feedback</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import SourceChipComponent from './SourceChipComponent.vue';
import axios from 'axios';
axios.defaults.withCredentials = true;


export default {
    props: {
        text: {
            type: String,
            required: true
        },
        timestamp: {
            type: String,
            required: false
        },
        conversation_id: {
            type: String,
            required: true
        }, sources: {
            type: Array,
            required: false
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        qanda_id: {
            type: String,
            required: false
        },
        has_feedback: {
            type: Boolean,
            required: false,
            default: false
        },
        fromAdmin: {
            type: Boolean,
            required: false,
            default: false
        },
        has_admin_feedback: {
            type: Boolean,
            required: false,
            default: false
        },
        streamAhora: {
            type: Boolean,
            required: false,
            default: false
        },


    },
    components: {
        SourceChipComponent,
    },
    // if sources change, update the groupedSources
    watch: {
        sources: {
            handler: function (newSources) {
                if (!this.isLoading) {
                    let usedSources = this.getUsedSources(this.text);
                    this.groupedSources = this.groupSources(newSources, usedSources)
                }
            },
            immediate: true
        },
        text: {
            handler() {
                if (this.streamAhora) {
                    this.iniciarStriming();
                }
            },
            immediate: true,
        },
    },
    data() {
        return {
            showTimestamp: true,
            botname: process.env.VUE_APP_BOT_PUBLIC_NAME,
            providedFeedback: false,
            providedFeedbackAdmin: false,
            providedDetailedFeedback: false,
            providedDetailedFeedbackAdmin: false,
            feedbackValue: null,
            feedbackDetail: '',
            base_url: process.env.VUE_APP_BASE_URL,
            groupedSources: [],
            mensajeCompleto: "",
            mensajeMostrado: "",
            intervalId: null,
        };
    },
    computed: {
        formattedTimestamp() {
            const date = new Date(this.timestamp + 'Z'); // Ensure the timestamp is treated as UTC
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            };
            return date.toLocaleString('es-AR', options);
        },
        parsedText() {
            return this.withSourceLink(DOMPurify.sanitize(marked(this.getOutput(this.text))));
        }
    },
    methods: {
        compartirPregunta() {
            // Crea un enlace a chatpts.laizquierdadiario.com/preguntas-publicas/{qanda_id}
            // Copiarlo al portapapeles
            // mostrar toas de éxito
            let url = `https://chatpts.laizquierdadiario.com/preguntas-publicas/${this.qanda_id}`;
            navigator.clipboard.writeText(url);
            this.showToast("Enlace copiado al portapapeles", "success");
        },
        iniciarStriming() {
            // Limpiar cualquier intervalo previo
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }

            // Obtener el HTML limpio y seguro
            this.mensajeCompleto = this.parsedText;

            // Dividimos el contenido en palabras o partes para hacerlo más interactivo
            const partes = this.mensajeCompleto.split(" ");
            this.mensajeMostrado = ""; // Resetear el mensaje mostrado
            let index = 0;

            // Inicializamos el intervalo para ir mostrando el contenido gradualmente
            this.intervalId = setInterval(() => {
                if (index < partes.length) {
                    // Añadir parte al mensaje mostrado
                    this.mensajeMostrado += partes[index] + " ";
                    index++;
                } else {
                    // Si ya se ha mostrado todo, limpiamos el intervalo
                    clearInterval(this.intervalId);
                }
            }, 50); // Cambia 100 para ajustar la velocidad del striming
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.text);
        },
        withSourceLink(text) {
            // Find text that matches the regex '[<number from 1 to 100>]' and replace it with a link to the source
            // the url will be in sources where the source.source_number matches the number in the brackets
            return text.replace(/\[\d{1,3}\]/g, (match) => {
                const sourceNumber = match.slice(1, -1);
                const source = this.sources.find((source) => source.source_number === sourceNumber);
                if (source) {
                    return `<a href="${source.url}" target="_blank">${match}</a>`;
                }
                return match;
            });
        },
        sendFeedbackSimple(admin) {
            let simple_feedback_path = !admin ? "/api/v2/feedback/set-qanda-feedback/" : "/api/v2/admin-feedback/set-admin-qanda-feedback/";


            if (this.feedbackValue !== null) {
                axios.post(this.base_url + simple_feedback_path, {
                    feedback: this.feedbackValue,
                    qanda_id: this.qanda_id
                }).then(() => {
                    this.showToast("¡Gracias! Feedback enviado correctamente.", "success");

                }).catch((error) => {
                    console.error('Error al enviar feedback:', error);
                    this.showToast("¡Estamos con mucha demanda! al intentar enviar el feedback. Por favor, intenta de nuevo nuevamente.", "warning");

                });
            }
        },
        sendFeedbackDetail(admin) {
            let detailed_feedback_path = !admin ? "/api/v2/feedback/set-qanda-feedback-detail/" : "/api/v2/admin-feedback/set-admin-qanda-feedback-detail/";


            if (this.feedbackDetail) {
                axios.post(this.base_url + detailed_feedback_path, {
                    feedback: this.feedbackValue,
                    feedback_detail: this.feedbackDetail,
                    qanda_id: this.qanda_id
                },).then(() => {
                    this.showToast("¡Gracias! Feedback enviado correctamente.", "success");
                }).catch((error) => {
                    console.error('Error al enviar feedback detallado:', error);
                    this.showToast("¡Estamos con mucha demanda! al intentar enviar el detalle del feedback. Por favor, intenta de nuevo nuevamente.", "warning");
                });
            }
        },
        sendPositiveFeedback() {
            this.providedFeedback = true;
            this.feedbackValue = 1;
            this.sendFeedbackSimple(false);
        },
        sendNegativeFeedback() {
            this.providedFeedback = true;
            this.feedbackValue = 0;
            this.sendFeedbackSimple(false);
        },
        sendDetailedFeedback() {
            this.providedDetailedFeedback = true;
            this.sendFeedbackDetail(false);
        },
        sendPositiveFeedbackAdmin() {
            this.providedFeedbackAdmin = true;
            this.feedbackValue = 1;
            this.sendFeedbackSimple(true);
        },
        sendNegativeFeedbackAdmin() {
            this.providedFeedbackAdmin = true;
            this.feedbackValue = 0;
            this.sendFeedbackSimple(true);
        },
        sendDetailedFeedbackAdmin() {
            this.providedDetailedFeedbackAdmin = true;
            this.sendFeedbackDetail(true);
        },
        cancelNumericFeedback() {
            this.providedFeedback = false;
            this.feedbackValue = null;
        },
        cancelarFeedback() {
            this.providedFeedback = false;
            this.providedDetailedFeedback = false;
            this.feedbackValue = null;
            this.feedbackDetail = '';
        },
        groupSources(sources, usedSources) {
            if (!sources) {
                return [];
            }
            const groupedSources = [];


            const seenUrls = new Map();
            const seenFilenames = new Map();

            sources.forEach(source => {
                if (source.url && !source.filename) {
                    // Group by URL
                    if (!seenUrls.has(source.url)) {
                        // First time we see this URL, add the full source and initialize sources_number array
                        seenUrls.set(source.url, {
                            ...source,
                            sources_number: [source.source_number] // Store the first source_number
                        });
                    } else {
                        // If the URL is already grouped, push the new source_number
                        seenUrls.get(source.url).sources_number.push(source.source_number);
                    }
                } else if (source.filename) {
                    // Group by filename
                    if (!seenFilenames.has(source.filename)) {
                        // First time we see this filename, add the full source and initialize pages and sources_number
                        seenFilenames.set(source.filename, {
                            ...source,
                            pages: [source.page], // Store the first page number
                            sources_number: [source.source_number], // Store the first source_number
                            url: source?.url,
                            sinopsis: source?.sinopsis,
                            title: source?.title,
                            autor: source?.autor,
                        });
                    } else {
                        // Append the page number and the source_number to the already existing filename entry
                        const existingEntry = seenFilenames.get(source.filename);
                        existingEntry.pages.push(source.page);
                        existingEntry.sources_number.push(source.source_number);
                    }
                }
            });

            // Combine the grouped sources from both URL and filename groups
            seenUrls.forEach(value => {
                delete value.source_number; // Remove individual source_number
                groupedSources.push(value);
            });
            seenFilenames.forEach(value => {
                delete value.source_number; // Remove individual source_number
                delete value.page; // Remove individual page
                groupedSources.push(value);
            });

            // Finally, filter the grouped sources to only include the ones that are used in the text
            // Print length of groupedSources before and after filtering
            let filteredGroupedSources = [];
            groupedSources.forEach(groupedSource => {
                // For source_number in groupedSource.sources_number, check if it is used in the text, convert to int
                // If any of the source_numbers is used, keep the groupedSource in groupedSources, otherwise remove it
                if (groupedSource.sources_number.some(sourceNumber => usedSources?.includes(parseInt(sourceNumber)))) {
                    filteredGroupedSources.push(groupedSource);
                }

            });

            return filteredGroupedSources;
        },
        getUsedSources(text) {
            // Return a list of source numbers that are used in the text in format [number],[number2]
            const sourceNumbers = text.match(/\[\d{1,3}\]/g);
            if (!sourceNumbers) {
                return [];
            }
            return [...(new Set(sourceNumbers.map(sourceNumber => parseInt(sourceNumber.slice(1, -1)))))];
        },
        getOutput(text) {
            //Return content between <output> and </output>. If not found, return the text
            const outputRegex = /<output>([\s\S]*?)<\/output>/;
            const match = text.match(outputRegex);
            if (match) {
                return match[1];
            }
            return text;
        },
        showToast(message, type) {
            this.$emit('show-toast', message, type);
        }
    },

    beforeUnmount() {
        // Limpiar el intervalo si el componente es destruido
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
};
</script>

<style>
.kotbot-message-with-feedback {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 24px;
    width: 100%;
}

.kotbot-message-with-feedback a {
    color: #a1344e;
    font-weight: 600;
}


.kotbot-message {
    cursor: pointer;
    margin-bottom: 24px;
    background-color: #fafafa;
    padding: 24px;
    border-radius: 12px 12px 12px 0;
    box-shadow: -5px 0 12px 1px rgba(0, 0, 0, 0.1);
    min-width: 60%;
    max-width: 85%;
    font-size: 13pt;
    border: 1px solid #ccc;
    line-height: 1.2;
    position: relative;
    z-index: 2;
}

.timestamp {
    font-size: 12pt;
    color: gray;
    margin-top: 6px;
    padding-left: 24px;
    letter-spacing: 1px;
}

.kotbot-message .message-text {
    margin-bottom: 48px;
    padding-left: 24px;
}

.kotbot-message .message-text.loading {
    margin-bottom: 12px;
}

.cargando-titulo {
    margin-top: 0;
    margin-bottom: 12px;
    font-size: 20pt;
    color: #a1344e;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding-left: 24px;
}

/* Add looping animation to the dots */
.dot-1,
.dot-2,
.dot-3 {
    animation: blink 1s infinite ease-in-out;
}

.dot-2 {
    animation-delay: 0.2s;
}

.dot-3 {
    animation-delay: 0.4s;
}

.botones {
    display: flex;
    justify-content: flex-start;
    padding-left: 24px;
}

.botones ion-icon {
    margin-right: 12px;
    font-size: 16pt;
}


.compartirPregunta {
    font-size: 12pt;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    border: 2px solid #a1344e;
    background-color: #a1344e;
    color: white;
    margin-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.compartirPregunta:hover {
    background-color: white;
    color: #a1344e;
}

.copiarPregunta {
    font-size: 12pt;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    border: 2px solid #a1344e;
    background-color: white;
    color: #a1344e;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.copiarPregunta:hover {
    background-color: #a1344e;
    color: white;
}

@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}


.message-text h1,
.message-text h2,
.message-text h3,
.message-text h4,
.message-text h5,
.message-text h6 {
    color: #a1344e;
    margin-top: 18px;
    margin-bottom: 6px;
}

.message-text li {
    margin-bottom: 6px;
    margin-left: 6px;
}


.message-text p,
.message-text ul {
    margin-bottom: 12px;
}

.message-text ul {
    padding-left: 12px;
}

.triangle {
    color: red;
}

.kotbot-message .triangle::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-right: 24px solid transparent;
    border-top: 24px solid #fff;
    left: 1px;
    bottom: -25px;
}

.sources-container {
    margin-top: 48px;
    margin-bottom: 24px;
    padding-left: 24px;
}


.sources-container h4 {
    margin-bottom: 12px;
}

.source-chips {
    display: flex;
    flex-wrap: wrap;
}

.message-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.message-photo {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    border-radius: 20px;
    overflow: hidden;
    border: 2px solid #444;
    display: flex;
    justify-content: center;
    align-items: center;
}

.message-photo img {
    width: 80%;
    height: 80%;
}

.kotbot-message-with-feedback .feedback-macro-container {
    margin-top: 24px;
    position: sticky;
    top: 24px;
    display: flex;
    flex-direction: column;
    background-color: #ccc;
    border-left: none;
    z-index: 1;
    border-radius: 0 8px 8px 0;
    padding: 12px;
    align-items: baseline;
    flex-grow: 0;
}

.feedback h4 {
    margin-bottom: 24px;
    color: #333;
}


.feedback button {
    font-size: 14pt;
    margin: 0 6px;
    margin-bottom: 12px;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    border: none;
}

.feedback button:hover {
    background-color: #a1344e;
    border-color: #a1344e;
}

.detailed-feedback {
    display: flex;
    flex-direction: column;
}

.detailed-feedback p {
    margin-bottom: 24px;
}


.detailed-feedback textarea {
    width: 100%;
    flex-grow: 1;
    margin-bottom: 24px;
    padding: 12px;
    font-size: 12pt;
    min-height: 80px;
}

.detailed-feedback button {
    font-size: 16pt;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    background-color: #a1344e;
    border: 2px solid #a1344e;
    text-transform: uppercase;
    color: #fff;
    flex-grow: 2;
    font-weight: bold;
}

.detailed-feedback button.secondary {
    background-color: transparent;
    color: #a1344e;
    border: 2px solid #a1344e;
    flex-grow: 1;
    font-weight: normal;
}

.detailed-feedback button:hover {
    background-color: white;
    color: #a1344e;
    border: 2px solid #a1344e;
}

.detailed-feedback-buttons {
    display: flex;
    justify-content: space-between;
}

.feedback-result>* {
    margin-bottom: 12px;
}

.feedback-result p span {
    font-weight: bold;
}

.feedback-result button {
    font-size: 12pt;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    background-color: transparent;
    border: 2px solid #a1344e;
    text-transform: uppercase;
    color: #a1344e;
    font-weight: bold;
    margin-top: 12px;
}

.feedback-result button:hover {
    background-color: #fff;
}

.numeric-feedback {
    display: flex;
    flex-direction: column;
    align-items: center;
}

@media screen and (max-width: 768px) {
    .kotbot-message-with-feedback {
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
    }

    .kotbot-message {
        max-width: 95%;
    }

    .source-chips {
        justify-content: center;
    }

    .kotbot-message .message-text {
        padding-left: 12px;
    }

    .sources-container {
        padding-left: 0;
    }

    .kotbot-message-with-feedback .feedback-macro-container {
        border-radius: 0 0 8px 8px;
        border-left: 2px solid #a1344e;
        border-top: none;
        padding: 12px;
        margin-top: 0;
        top: -24px;
        width: 70%;
        align-items: center;
        position: relative;
        align-self: center;
    }

    .feedback h4 {
        font-size: 12pt;
        margin-bottom: 12px;
    }

    .numeric-feedback {
        flex-direction: row;
    }
}
</style>
